import styled from 'styled-components';

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.lighterBackground};
  border-radius: 16px;
  padding: 18px;
  padding-top: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 8px;

  > button {
      border: none;
      background: transparent;
      /* margin-right: 8px; */


      img {
        padding: 0;
        width: 24px;

        &:hover {
          opacity: 0.7;
        }
          transition: all ease-in-out 0.2s;
      }
  }

  h3 {
    font-size: 18px;
    font-weight: bold;
    margin-top: 8px;
  }
`;

export const DataContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;

  h3 {
    margin-bottom: 12px;
  }
`;

export const InnerDataContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;

  h4 {
    font-size: 18px;
    font-weight: bold;
    opacity: 0.9;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;

    img {
      width: 18px;
    }

    img.left {
      transform: rotate(-90deg);
      width: 14px;
      margin-right: 8px;

      &:hover{
        opacity: 0.5;
        transition: ease-in 0.2s;
        cursor: pointer;
      }
      &:not(:hover) {
        opacity: 1;
        transition: ease-in 0.2s;
      }
    }

    img.right {
      transform: rotate(90deg);
      width: 14px;
      margin-left: 8px;

      &:hover{
        opacity: 0.5;
        transition: ease-in 0.2s;
        cursor: pointer;
      }
      &:not(:hover) {
        opacity: 1;
        transition: ease-in 0.2s;
      }
    }
  }

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }

  strong {
    margin-right: 2px;
    font-weight: bold;
    opacity: 1;
    font-size: 15px;
  }

  small {
        background: ${({ theme }) => theme.colors.blue[50]};
        color: ${({ theme }) => theme.colors.blue[900]};
        font-weight: bold;
        text-transform: uppercase;
        padding: 4px;
        border-radius: 4px;
        font-size: 11px;
        width: fit-content;
      }

      small.green {
          background: ${({ theme }) => theme.colors.green[100]};
          color: ${({ theme }) => theme.colors.green[500]};
      }

      small.orange {
          background: ${({ theme }) => theme.colors.orange[100]};
          color: ${({ theme }) => theme.colors.orange[500]};
        }

      small.gray {
        background: ${({ theme }) => theme.colors.gray[100]};
        color: ${({ theme }) => theme.colors.gray[900]};
      }

      small.red {
        background: ${({ theme }) => theme.colors.danger.light};
        color: ${({ theme }) => theme.colors.danger.dark};
      }
`;

export const SelectedViewContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  height: 100%;
`;

